export default __webpack_public_path__ + "static/arc-094b3c58423f47e7012e31dafbfbfc72.png";